var _style, _rect, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelectedIcp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Checkbox Selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.checkboxBkgICP{fill:#2E8B85;}\r\n\t\t.checkICP{fill:#FFFFFF;}\r\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "checkboxBkgICP",
    x: 0.05,
    width: 24,
    height: 24
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "checkICP",
    points: "11.8 19.9 4.6 12.7 6 11.3 11.4 16.6 17.8 5.3 19.5 6.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelectedIcp);
export default __webpack_public_path__ + "static/media/checkbox-selected-icp.b125e1a7b8eb573b2049b8278ce4ec5a.svg";
export { ForwardRef as ReactComponent };